import React from 'react';

const Paragraph = ({
    children,
    small = false,
    normal = false,
    medium = false,
    large = false,
    color="#181818"
  }) => {
    const classList = ['paragraph'];
  
    if (small) classList.push('Small');
    else if (normal) classList.push('Normal');
    else if (medium) classList.push('Medium');
    else if (large) classList.push('Large');
  
    return (
      <p
      style={{color: color}}
        className={classList.join(' ')}
      >
        {children}
      </p>
    );
  };

  export default Paragraph;


// WEBPACK FOOTER //
// ./src/components/theme/Paragraph/Paragraph.jsx